<template>
  <table
    class="cur-kv"
    :class="{
      'dt-loading': selectedOrder.order_details_tab_summary_loading,
    }"
  >
    <tr>
      <td>{{ $t("quantity") }}:</td>
      <td>
        {{
          $dft.integer(
            selectedOrder &&
              selectedOrder.order_details_tab_summary &&
              selectedOrder.order_details_tab_summary.order_summary &&
              selectedOrder.order_details_tab_summary.order_summary.qty
          )
        }}
        <span style="display: inline-block; opacity: 0; width: 26px">|EUR</span>
      </td>
    </tr>
    <tr>
      <td>{{ $t("subtotal") }}:</td>
      <td>
        {{ $dft.curr(selectedOrder.subtotal) }}        
        {{ selectedOrder && selectedOrder.orderCurrency }}
      </td>
    </tr>
    <tr>
      <td>
        {{ $t("discount") }} ({{
          selectedOrder &&
          selectedOrder.order_details_tab_summary &&
          selectedOrder.order_details_tab_summary.order &&
          selectedOrder.order_details_tab_summary.order.order_discount
            ? Number.isInteger(
                +selectedOrder.order_details_tab_summary.order.order_discount
              )
              ? $dft.integer(
                  selectedOrder.order_details_tab_summary.order.order_discount
                )
              : $dft.curr(
                  selectedOrder.order_details_tab_summary.order.order_discount
                )
            : 0
        }}%):
      </td>
      <td>
        {{ $dft.curr(selectedOrder.discount_amount) }}
        
        {{ selectedOrder && selectedOrder.orderCurrency }}
        <div style="position: relative">
          <div
            style="position: absolute; top: -11px; right: -28px"
            class="dt-icon-container"
          >
            <img
              @click="(e) => onClickEditDiscount(e)"
              src="static/icons/edit-blue.svg"
              class="dt-icon v5 s1"
            />
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td>{{ $t("shipping_costs") }}:</td>
      <td>
        {{ $dft.curr(selectedOrder.shipping_costs) }}
        
        {{ selectedOrder && selectedOrder.orderCurrency }}
        <div style="position: relative">
          <div
            style="position: absolute; top: -11px; right: -28px"
            class="dt-icon-container"
          >
            <img
              @click="(e) => onClickEditShippingCosts(e)"
              src="static/icons/edit-blue.svg"
              class="dt-icon v5 s1"
            />
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td>{{ $t("total_product") }}:</td>
      <td class="ut-text-primary" style="font-weight: 700">
        {{ $dft.curr(selectedOrder.total_cost) }}
        {{ selectedOrder && selectedOrder.orderCurrency }}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    selectedOrder: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onClickEditDiscount: function () {
      document.getElementById("deliveryInfoDiscount").scrollIntoView({
        behavior: "smooth",
      });
    },
    onClickEditShippingCosts: function () {
      document.getElementById("shipping").scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
</style>